import styled, { css } from 'styled-components';
import { Button, Typography, Wrapper } from '@trader/components';
import { conditionApply } from '@trader/utils';
import { modalHorizontalPadding } from '@trader/constants';

export const Root = styled(Wrapper)`
  ${() => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    width: 408px;
    height: 390px;
  `}
`;

export const Main = styled(Wrapper)`
  ${() => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  `}
`;

export const Symbol = styled(Typography)`
  ${() => css`
    font-weight: 700;
    font-size: 15px;
  `}
`;

export const Description = styled(Typography)`
  ${() => css`
    font-weight: 400;
    font-size: 12px;
    max-width: 100%;
  `}
`;

export const Info = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 74px;
    border-bottom: 1px solid ${theme.palette.background.default};
    padding: 0 ${modalHorizontalPadding}px;
  `}
`;

export const InfoLeft = styled(Wrapper)`
  ${() => css`
    display: flex;
    align-items: center;
  `}
`;
export const SymbolInfo = styled(Wrapper)`
  ${() => css`
    flex-direction: column;
    margin-left: 7px;
  `}
`;

export const InfoRight = styled(Wrapper)`
  ${() => css`
    display: flex;
    align-items: center;
    flex-direction: column;
  `}
`;

export const Placeholder = styled(Typography)`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 12px;
    color: ${theme.palette.gray.main};
  `}
`;

export const Price = styled(Typography)`
  ${() => css`
    font-weight: 400;
    font-size: 15px;
  `}
`;

export const Buttons = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 110px;
    border-bottom: 1px solid ${theme.palette.background.default};
    margin-bottom: 17px;
    padding: 0 ${modalHorizontalPadding}px;
  `}
`;

interface IButtonType {
  $isSelected: boolean;
}

export const ButtonType = styled(Button)<IButtonType>`
  ${({ theme, $isSelected }) => css`
    width: 182px;
    height: 50px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 5px;
    border: 1px solid ${theme.palette.common.black};
    background-color: transparent;
    color: ${theme.palette.common.black};

    ${theme.breakpoints.down('sm')} {
      width: 162px;
    }

    &:hover {
      background: transparent;
      color: ${theme.palette.common.black};
    }

    ${conditionApply(
      [$isSelected],
      css`
        border: 1px solid ${theme.palette.purchaseButtons.green};
        background: ${theme.palette.purchaseButtons.green};
        color: ${theme.palette.common.white};

        &:hover {
          background: ${theme.palette.purchaseButtons.green};
          color: ${theme.palette.common.white};
        }
      `
    )};
  `}
`;

export const Input = styled(Wrapper)`
  ${() => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 0 ${modalHorizontalPadding}px;
  `}
`;

export const InputLabel = styled(Typography)`
  ${() => css`
    font-weight: 400;
    font-size: 14px;
  `}
`;
